import type { KeywordDefinition } from 'ajv';

export const maxLength: KeywordDefinition = {
  type: 'string',
  keyword: 'maxLength',
  validate(schema: number | null, data: string) {
    if (schema == null) {
      return true;
    }
    return data.length <= schema;
  },
};

export const minLength: KeywordDefinition = {
  type: 'string',
  keyword: 'minLength',
  validate(schema: number | null, data: string) {
    if (schema == null) {
      return true;
    }
    return data.length >= schema;
  },
};
